import './header.scss';

/**
 * version    1.0
 * class      <type> (Header)
 * classdesc  Component that manage the page header
 */
export class Header {}
